export default {
    SHARED_SECRET: 100,
    X509_CERTIFICATE_BASE64: 200,
}